<p-card class="p-card container">
  @if (title) {
    <h3>{{ title }}</h3>
  }

  <div class="layout--column layout--gap-medium">
    @for (f of form.controls; track f; let i = $index) {
      <em-sale-report
        [index]="i"
        [hasTitle]="form.controls.length > 1"
        [form]="f"
        [secretCode]="f.get('secretCode')?.value"></em-sale-report>
    }
  </div>
</p-card>
